document.addEventListener('DOMContentLoaded', () => {

  function normalizeText(text) {
    return String(text || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function escapeRegExp(text) {
    return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function getSelectedSize() {
    const selects = document.querySelectorAll('select');

    for (const select of selects) {
      const value = normalizeText(select.value);
      if (!value) continue;

      const context = normalizeText(
        (select.name || '') + ' ' +
        (select.id || '') + ' ' +
        (select.closest('label')?.textContent || '') + ' ' +
        (select.parentElement?.textContent || '')
      ).toLowerCase();

      if (
        context.includes('tamanho') ||
        context.includes('size')
      ) {
        return value;
      }
    }

    return null;
  }

  function getSizeLine(guide, size) {
    guide = normalizeText(guide);
    size = normalizeText(size);

    if (!guide || !size) return null;

    const sizePattern = escapeRegExp(size);

    const nextSize =
      '(?=\\s+(?:XXXS|XXS|XS|S|M|L|XL|XXL|XXXL|2XL|3XL|4XL|5XL|6XL|\\d{2,3})\\s*(?:—|-|:)|$)';

    const regex = new RegExp(
      '(?:^|\\s)' +
      sizePattern +
      '\\s*(?:—|-|:)\\s*' +
      '(.+?)' +
      nextSize,
      'i'
    );

    const match = guide.match(regex);

    if (!match) return null;

    return normalizeText(match[1]);
  }

  function updateMeasurement() {
    const output = document.querySelector('[data-shamar-size-measure]');
    if (!output) return;

    const guide = output.dataset.sizeGuide || '';
    const size = getSelectedSize();

    if (!guide || !size) {
      output.style.display = 'none';
      return;
    }

    const measurement = getSizeLine(guide, size);

    if (!measurement) {
      output.style.display = 'none';
      return;
    }

    output.textContent =
      'Medidas do tamanho selecionado: ' +
      size +
      ' — ' +
      measurement;

    output.style.display = 'block';
  }

  updateMeasurement();

  document.addEventListener('change', (event) => {
    if (event.target.matches('select')) {
      setTimeout(updateMeasurement, 50);
    }
  });

});